<template>
    <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        width="32.000000" height="32.000000" fill="none">
        <rect id="svg" width="32.000000" height="32.000000" x="0.000000" y="0.000000" />
        <path id="4863" d="M24 21.3334L29.3333 16.0001L24 10.6667" fill-rule="nonzero" stroke="rgb(212,175,55)"
            stroke-linecap="round" stroke-linejoin="round" stroke-width="2.666667" />
        <path id="4864" d="M8.00033 10.6667L2.66699 16.0001L8.00033 21.3334" fill-rule="nonzero"
            stroke="rgb(212,175,55)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.666667" />
        <path id="4865" d="M19.3337 5.33325L12.667 26.6666" stroke="rgb(212,175,55)" stroke-linecap="round"
            stroke-linejoin="round" stroke-width="2.666667" />
    </svg>
</template>
